import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { GenericErrorHandlerService } from '../../../core/services/generic-error-handler.service';

@Component({
    selector: 'ns-new-password',
    templateUrl: './new-password.component.html',
    styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit, OnDestroy {

    public subscription: Subscription = new Subscription();
    public showPasswordErr = false;
    private readonly token: string;

    private isRegisterView = false;

    public form: FormGroup = this.formBuilder.group({
        newPassword: [null, [Validators.required]],
    });

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private genericErrorHandlerService: GenericErrorHandlerService
    ) {
        this.token = activatedRoute.snapshot.queryParams['token'] ? activatedRoute.snapshot.queryParams['token'] : null;

        this.isRegisterView = activatedRoute.snapshot.queryParams['register'] ? !!activatedRoute.snapshot.queryParams['register'] : false;
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onSubmit() {
        this.genericErrorHandlerService.showErrors(this.form);

        if (this.form.valid) {

            if (this.isRegisterView) {
                this.authService.registerPassword({
                    newPassword: this.form.get('newPassword').value,
                    createPasswordToken: this.token
                })
                    .then(() => this.router.navigate(['logowanie']));

            } else {

                this.authService.newPassword({
                    password: this.form.get('newPassword').value,
                    token: this.token
                })
                    .then(() => this.router.navigate(['logowanie']));

            }

        }
    }

}
